import * as React from "react";
import { Redirect, RouteComponentProps } from "react-router";
import ProductOptionModerationContainer from "~/containers/ProductOptionModerationContainer";
import { getUserSlug } from "~/util/getUserSlug";

export default class ProductOptionModeration extends React.Component<
  RouteComponentProps<{}>
> {
  public render() {
    if (!getUserSlug()) {
      return (
        <Redirect
          to={{
            pathname: "/auth",
            state: { from: this.props.location }
          }}
        />
      );
    }

    return <ProductOptionModerationContainer />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProductOptionModeration.tsx